"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var student_orders_html_1 = __importDefault(require("./student-orders.html"));
var student_orders_controller_1 = __importDefault(require("./student-orders.controller"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.instructor.dashboard.studentorders", {
        url: "/student-orders/:student_id",
        controller: student_orders_controller_1.default,
        controllerAs: "vm",
        template: student_orders_html_1.default,
        resolve: {
            student: getStudent,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.owner,
                USER_ROLES.instructor,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
function getStudent($stateParams, UsersModel) {
    return UsersModel.getStudentByID($stateParams.student_id).then(function (response) {
        return response;
    });
}
getStudent.$inject = ["$stateParams", "UsersModel"];
exports.default = angular_1.default
    .module("instructor.dashboard.studentorders", [])
    .config(config)
    .controller("InstructorsStudentOrdersController", student_orders_controller_1.default);
